import { render, staticRenderFns } from "./NoSideBar.vue?vue&type=template&id=1623f448&"
import script from "./NoSideBar.vue?vue&type=script&lang=js&"
export * from "./NoSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports